import {
  OPERATION,
  MOBILE_LINE_ACTIONS,
  SIM_TYPES,
} from '@/constants/operation';
import { LINE_TYPE } from '@/constants/constant';
import { ORION_TEXTS_IDS } from '@/constants/pages/miMovistar';
import { CLIENT_ORION_TEXTS_IDS } from '@/constants/pages/mobileLines';
import { findText } from '..';

export const getDeliveryText = (texts) => {
  return (
    texts?.find(
      (text) => text.id === CLIENT_ORION_TEXTS_IDS.SHOP_SHIPMENT_DELIVERY
    )?.description || null
  );
};

export const getSimDeliveryText = (texts, deliveryMethod = '') => {
  let returnText =
    texts?.find((text) => text.id === ORION_TEXTS_IDS.DELIVERY)?.description ||
    null;
  if (deliveryMethod === 'SHOP') {
    returnText =
      texts?.find((text) => text.id === ORION_TEXTS_IDS.SHOP)?.description ||
      null;
  }
  return returnText;
};

export const calculateShippingText = ({ orionTexts, operationFormData }) => {
  const cardsChosen = [
    ...new Set(
      operationFormData
        .filter((item) => item.type === LINE_TYPE.MOBILE_LINE)
        .map((item) => item[OPERATION.CARD_CHOICER.ID]?.value)
    ),
  ];
  const isMobilePortabilityChosen = operationFormData.some(
    (item) =>
      item.type === LINE_TYPE.MOBILE_LINE &&
      item[OPERATION.ACTION_CHOICER.ID]?.value ===
      MOBILE_LINE_ACTIONS.PORTABILITY
  );
  let shippingText = {};
  if (cardsChosen.length === 1) {
    const [cardChosen] = cardsChosen;
    if (cardChosen === SIM_TYPES.ESIM) {
      shippingText = {
        ...findText({
          texts: orionTexts,
          textId: ORION_TEXTS_IDS.DIGITAL_DELIVERY,
        }),
        simSelected: false,
      };
    } else if (cardChosen === SIM_TYPES.SIM) {
      shippingText = {
        ...findText({
          texts: orionTexts,
          textId: ORION_TEXTS_IDS.SHOP,
        }),
        simSelected: true,
      };
    }
  } else if (cardsChosen.length > 1) {
    shippingText = {
      ...findText({
        texts: orionTexts,
        textId: ORION_TEXTS_IDS.SHOP,
      }),
      esimText: {
        ...findText({
          texts: orionTexts,
          textId: ORION_TEXTS_IDS.DIGITAL_DELIVERY,
        }),
      },
      simSelected: true,
    };
  }
  if (isMobilePortabilityChosen) {
    const portabilityText = {
      ...findText({
        texts: orionTexts,
        textId: ORION_TEXTS_IDS.PORTABILITY,
      }),
    };
    const { description: portabilityDesc } = { ...portabilityText };
    shippingText.portabilityText = portabilityDesc;
    shippingText.description = `${shippingText?.description ? `${shippingText?.description} </br>` : ''
      }${portabilityDesc}`;
  }
  return shippingText;
};

export const getUpdateNote = (texts) => {
  return (
    texts?.find((text) => text.id === ORION_TEXTS_IDS.UPDATE_NOTE)
      ?.description || null
  );
};
export const getNextSteps = (texts) => {
  const steps =
    texts?.filter(
      (text) =>
        text.id === ORION_TEXTS_IDS.CART ||
        text.id === ORION_TEXTS_IDS.CART_LEGALS
    ) || null;

  return steps?.map((item) => item.description).join(' ');
};

export const getFlyoutById = (jsonString, idToSearch) => {
  const root =
    typeof jsonString === 'string' ? JSON.parse(jsonString) : jsonString;
  const flyouts = root?.data?.fields?.['XGSPON-FLYOUT'];

  const flyout10 = flyouts.find((f) => f.alias === ORION_TEXTS_IDS.XGSPON10);
  const flyout5 = flyouts.find((f) => f.alias === ORION_TEXTS_IDS.XGSPON5);

  if (!flyout10 || !flyout5) {
    return null;
  }

  const found = flyout10.fields.productOffering.includes(idToSearch);
  return found ? flyout10.fields : flyout5.fields;
};

export const getXGSPONTexts = (texts, poId) => {
  const rawtexts =
    texts?.find((text) => text.id === ORION_TEXTS_IDS.XGSPON_MODAL)
      ?.description || null;

  return getFlyoutById(rawtexts, poId);
};
